import { createFileRoute } from '@tanstack/react-router';

import { baggageDisruptionSearchSchema } from '@/features/baggage-disruption/schemas/baggage-disruption-search.schema';
import { BaggageDisruptionPage } from '@/pages/baggage-disruption.page';

export const Route = createFileRoute('/_authenticated/contracts/$contractId/baggage-disruption')({
  component: BaggageDisruptionPage,
  validateSearch: (search) =>
    baggageDisruptionSearchSchema.parse({ disruptionLocalId: search.disruptionLocalId }),
});
